import { isEmpty, isFunction, isArray, get, pick } from 'lodash-es';
import { yesterday } from '../../../utils/date';

import api from '../api';
import { preselectedForecast } from '../configs/forecasts-config';

export const CHANGE_PAGE = 'CHANGE_PAGE';
// MARKET REPORTS
export const FETCH_MARKET_REPORTS_REQUEST = 'FETCH_MARKET_REPORTS_REQUEST';
export const FETCH_MARKET_REPORTS_SUCCESS = 'FETCH_MARKET_REPORTS_SUCCESS';
export const FETCH_MARKET_REPORTS_FAILURE = 'FETCH_MARKET_REPORTS_FAILURE';
// RESEARCH LIBRARY
export const FETCH_REPORTS_REQUEST = 'FETCH_REPORTS_REQUEST';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAILURE = 'FETCH_REPORTS_FAILURE';
export const CHANGE_RESEARCH_LIBRARY_FILTERS = 'CHANGE_RESEARCH_LIBRARY_FILTERS';
export const CHANGE_TICKERS = 'CHANGE_TICKERS';
// CUSTOM EXPORTS
export const UPDATE_CUSTOM_EXPORTS_REQUEST = 'UPDATE_CUSTOM_EXPORTS_REQUEST';
export const UPDATE_CUSTOM_EXPORTS_SUCCESS = 'UPDATE_CUSTOM_EXPORTS_SUCCESS';
export const UPDATE_CUSTOM_EXPORTS_FAILURE = 'UPDATE_CUSTOM_EXPORTS_FAILURE';
export const UPDATE_CUSTOM_EXPORT_PROGRESS = 'UPDATE_CUSTOM_EXPORT_PROGRESS';
export const UPDATE_CUSTOM_EXPORTS_QUEUE_POSITIONS = 'UPDATE_CUSTOM_EXPORTS_QUEUE_POSITIONS';
export const PATCH_CUSTOM_EXPORT_STATE = 'PATCH_CUSTOM_EXPORT_STATE';
export const FETCH_CUSTOM_EXPORTS_REQUEST = 'FETCH_CUSTOM_EXPORTS_REQUEST';
export const FETCH_CUSTOM_EXPORTS_SUCCESS = 'FETCH_CUSTOM_EXPORTS_SUCCESS';
export const FETCH_CUSTOM_EXPORTS_FAILURE = 'FETCH_CUSTOM_EXPORTS_FAILURE';
export const CHANGE_SELECTION = 'CHANGE_SELECTION';
export const CHANGE_CUSTOM_EXPORTS_PER_PAGE = 'CHANGE_CUSTOM_EXPORTS_PER_PAGE';
// CUSTOM REPORTS
export const FETCH_CUSTOM_REPORTS_REQUEST = 'FETCH_CUSTOM_REPORTS_REQUEST';
export const FETCH_CUSTOM_REPORTS_SUCCESS = 'FETCH_CUSTOM_REPORTS_SUCCESS';
export const FETCH_CUSTOM_REPORTS_FAILURE = 'FETCH_CUSTOM_REPORTS_FAILURE';
export const FETCH_VERSIONS_REQUEST = 'FETCH_VERSIONS_REQUEST';
export const FETCH_VERSIONS_SUCCESS = 'FETCH_VERSIONS_SUCCESS';
export const FETCH_VERSIONS_FAILURE = 'FETCH_VERSIONS_FAILURE';
export const CHANGE_CUSTOM_REPORTS_PER_PAGE = 'CHANGE_CUSTOM_REPORTS_PER_PAGE';

// KPI FORECASTS
export const FETCH_KPI_FORECASTS_REQUEST = 'FETCH_KPI_FORECASTS_REQUEST';
export const FETCH_KPI_FORECASTS_SUCCESS = 'FETCH_KPI_FORECASTS_SUCCESS';
export const FETCH_KPI_FORECASTS_FAILURE = 'FETCH_KPI_FORECASTS_FAILURE';

// CURRENT FORECAST
export const FETCH_CURRENT_KPI_FORECAST_REQUEST = 'FETCH_CURRENT_KPI_FORECAST_REQUEST';
export const FETCH_CURRENT_KPI_FORECAST_SUCCESS = 'FETCH_CURRENT_KPI_FORECAST_SUCCESS';
export const FETCH_CURRENT_KPI_FORECAST_FAILURE = 'FETCH_CURRENT_KPI_FORECAST_FAILURE';
export const SELECT_KPI_FORECAST = 'SELECT_KPI_FORECAST';

// CHANGE PAGE
export const changePage = (currentPage) => ({
  type: CHANGE_PAGE,
  currentPage,
});

// MARKET REPORTS
export const fetchMarketReports =
  (filters = {}) =>
  (dispatch, getState) => {
    const { marketReports } = getState();
    const nextFilters = { ...marketReports.filters, ...filters };

    dispatch({
      type: FETCH_MARKET_REPORTS_REQUEST,
      filters,
    });

    api.marketReports
      .fetchReports({ filters: nextFilters })
      .then(
        ({
          data: {
            assets: { market_reports },
          },
        }) => {
          dispatch({
            type: FETCH_MARKET_REPORTS_SUCCESS,
            data: market_reports.reports,
            filters: market_reports.filters,
          });
        }
      )
      .catch(() => {
        dispatch({
          type: FETCH_MARKET_REPORTS_FAILURE,
          filters: marketReports.filters,
        });
      });
  };

// RESEARCH LIBRARY
export const fetchResearchLibraryData = () => (dispatch, getStore) => {
  const {
    researchLibrary: { filters },
  } = getStore();

  const params = {
    page: filters.page,
    filters: {
      ...filters,
      ...(filters.type.value !== 'all'
        ? { report_types: filters.type.list, order: filters.type.order || 'default' }
        : {}),
    },
    event_id: filters.eventId,
  };

  dispatch({ type: FETCH_REPORTS_REQUEST });
  api.researchLibrary
    .fetchReports(params)
    .then(({ data }) => {
      const newFilters = {
        ...filters,
        pagination: {
          ...filters.pagination,
          total_count: data.total_count,
        },
        eventId: data.event_id,
      };

      dispatch({
        type: FETCH_REPORTS_SUCCESS,
        data: data.reports,
        tickers: data.tickers,
        filters: newFilters,
      });
    })
    .catch(() => {
      dispatch({ type: FETCH_REPORTS_FAILURE });
    });
};

export const changeResearchLibraryFilters = (filters) => ({
  type: CHANGE_RESEARCH_LIBRARY_FILTERS,
  filters,
});

export const changeTickers = (tickers) => ({
  type: CHANGE_TICKERS,
  tickers,
});

// CUSTOM EXPORTS
export const fetchCustomExportsData =
  (filters = {}) =>
  (dispatch, getState) => {
    const { customExports } = getState();
    const nextFilters = { ...customExports.filters, ...filters };

    dispatch({ type: FETCH_CUSTOM_EXPORTS_REQUEST });
    api.customExports
      .fetchCustomExports(nextFilters)
      .then(({ data }) => {
        const action = !isEmpty(data) ? data.assets.reports : { list: [], filters: nextFilters };
        dispatch({ type: FETCH_CUSTOM_EXPORTS_SUCCESS, ...action });
      })
      .catch((error) => {
        if (!api.isCancel(error)) {
          dispatch({ type: FETCH_CUSTOM_EXPORTS_FAILURE });
        }
      });
  };

export const selectCustomExportsData =
  (reports = []) =>
  (dispatch, getState) => {
    const { customExports } = getState();
    dispatch({
      type: CHANGE_SELECTION,
      reports: isFunction(reports) ? reports(customExports.selectedExports) : reports,
    });
  };

export const updateCustomExportProgress = ({ id, progress }) => ({
  type: UPDATE_CUSTOM_EXPORT_PROGRESS,
  id,
  progress,
});

export const updateCustomExportsQueuePositions = ({ queuePositions }) => ({
  type: UPDATE_CUSTOM_EXPORTS_QUEUE_POSITIONS,
  queuePositions,
});

export const patchCustomExportState = ({ id, state, last_run_at }) => ({
  type: PATCH_CUSTOM_EXPORT_STATE,
  id,
  state,
  last_run_at,
});

export const updateCustomExportsData = (reportId) => (dispatch, getState) => {
  const { customExports } = getState();
  const selectedExportsIds = customExports.selectedExports.map((item) => item.id);
  if (!reportId && !selectedExportsIds.length) return;

  const apiRequest = reportId
    ? api.customExports.updateCustomExport(reportId, { custom_export: { end_date: yesterday() } })
    : api.customExports.updateCustomExports({
        custom_exports: selectedExportsIds.map((id) => ({ id, end_date: yesterday() })),
      });

  dispatch({
    type: UPDATE_CUSTOM_EXPORTS_REQUEST,
    listIds: reportId ? [reportId] : selectedExportsIds,
  });

  apiRequest
    .then(({ data }) => {
      dispatch({ type: UPDATE_CUSTOM_EXPORTS_SUCCESS, list: isArray(data) ? data : [data] });
    })
    .catch(() => {
      dispatch({
        type: UPDATE_CUSTOM_EXPORTS_FAILURE,
        listIds: reportId ? [reportId] : selectedExportsIds,
      });
    });
};

// CHANGE CUSTOM EXPORTS PER PAGE
export const changeCustomExportsPerPage = (perPage) => (dispatch) => {
  dispatch({
    type: CHANGE_CUSTOM_EXPORTS_PER_PAGE,
    perPage,
  });

  dispatch(fetchCustomExportsData());

  // Silent save user preference
  api.customExports.updatePerPage(perPage);
};

// CUSTOM REPORTS (APPTOPIA GENERATED EXPORTS)
export const fetchCustomReportsData =
  (filters = {}) =>
  (dispatch, getState) => {
    const { customReports } = getState();
    const nextFilters = {
      ...customReports.filters,
      ...filters,
      pagination: { ...customReports.filters.pagination, ...filters.pagination },
    };

    dispatch({ type: FETCH_CUSTOM_REPORTS_REQUEST });

    api.customReports
      .fetchCustomReports(nextFilters)
      .then(({ data }) => {
        const nextData = get(data, 'assets.custom_reports.reports_list', []);
        const totals = get(data, 'assets.custom_reports.filters.totals', 0);

        dispatch({
          type: FETCH_CUSTOM_REPORTS_SUCCESS,
          data: nextData,
          filters: {
            ...nextFilters,
            pagination: { ...nextFilters.pagination, total: totals },
          },
        });
      })
      .catch((error) => {
        if (!api.isCancel(error)) {
          dispatch({ type: FETCH_CUSTOM_REPORTS_FAILURE });
        }
      });
  };

export const fetchVersionsData = (params) => (dispatch) => {
  const reportId = params.custom_report_id;

  dispatch({ type: FETCH_VERSIONS_REQUEST });
  api.customReports
    .fetchVersionData(reportId)
    .then(({ data }) => {
      const nextData = get(data, 'assets.custom_reports_versions.versions_history', []);

      dispatch({
        type: FETCH_VERSIONS_SUCCESS,
        versionHistory: nextData,
        filters: { custom_report_id: reportId },
      });
    })
    .catch((error) => {
      if (!api.isCancel(error)) {
        dispatch({ type: FETCH_VERSIONS_FAILURE });
      }
    });
};

// CHANGE CUSTOM REPORTS PER PAGE
export const changeCustomReportsPerPage = (perPage) => (dispatch) => {
  dispatch({
    type: CHANGE_CUSTOM_REPORTS_PER_PAGE,
    perPage,
  });

  dispatch(fetchCustomReportsData());

  // Silent save user preference
  api.customReports.updatePerPage(perPage);
};

// CURRENT KPI FORECAST REQUEST
export const fetchCurrentForecasts =
  (filters = {}) =>
  (dispatch, getState) => {
    const { currentForecast } = getState();

    dispatch({
      type: FETCH_CURRENT_KPI_FORECAST_REQUEST,
      filters,
    });

    api.kpiForecasts
      .fetchCurrentForecasts(filters)
      .then(
        ({
          data: {
            assets: { current_forecast },
          },
        }) => {
          dispatch({
            type: FETCH_CURRENT_KPI_FORECAST_SUCCESS,
            data: pick(current_forecast, ['forecast', 'quarterly_forecasts_history']),
            filters: current_forecast.filters,
          });
        }
      )
      .catch(() => {
        dispatch({
          type: FETCH_CURRENT_KPI_FORECAST_FAILURE,
          filters: currentForecast.filters,
        });
      });
  };

// KPI FORECASTS REQUEST
export const fetchKpiForecasts = () => (dispatch) => {
  dispatch({ type: FETCH_KPI_FORECASTS_REQUEST });

  api.kpiForecasts
    .fetchKpiForecasts()
    .then(
      ({
        data: {
          assets: { forecasts },
        },
      }) => {
        const mergedForecasts = [...forecasts.my_forecasts, ...forecasts.all_forecasts];
        const defaultForecast = mergedForecasts[0];

        const active = preselectedForecast
          ? mergedForecasts.find((f) => f.ticker === preselectedForecast.ticker) || defaultForecast
          : defaultForecast;

        dispatch({
          type: FETCH_KPI_FORECASTS_SUCCESS,
          data: {
            active: active || {},
            ...pick(forecasts, ['my_forecasts', 'all_forecasts']),
          },
        });

        if (active) {
          const kpis = active.kpis || [];
          const defaultKpiId = kpis[0]?.kpi_id;

          dispatch(
            fetchCurrentForecasts({
              ticker: active.ticker,
              kpi_id: preselectedForecast?.kpi_id
                ? kpis.find((kpi) => kpi.kpi_id === preselectedForecast.kpi_id)?.kpi_id ||
                  defaultKpiId
                : defaultKpiId,
            })
          );
        }
      }
    )
    .catch(() => {
      dispatch({ type: FETCH_KPI_FORECASTS_FAILURE });
    });
};

export const selectKpiForecast = (forecast) => (dispatch, getState) => {
  const {
    forecasts: {
      data: { active },
    },
  } = getState();

  dispatch({
    type: SELECT_KPI_FORECAST,
    forecast,
  });

  if (forecast.ticker !== active.ticker) {
    const { quarters, kpi_id } = forecast.kpis[0] || {};

    dispatch(
      fetchCurrentForecasts({
        ticker: forecast.ticker,
        fy_quarter: quarters?.[0],
        kpi_id,
      })
    );
  }
};
